import { render, staticRenderFns } from "./ChatStudioView.vue?vue&type=template&id=4755465e&scoped=true"
import script from "./ChatStudioView.vue?vue&type=script&lang=js"
export * from "./ChatStudioView.vue?vue&type=script&lang=js"
import style0 from "./ChatStudioView.vue?vue&type=style&index=0&id=4755465e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755465e",
  null
  
)

export default component.exports